import { memo } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { styled } from '@mui/material'
import projectDefaultIcon from '../../../../assets/project_icon_default.svg'
import {
  programProjectReportRowService,
  ProgramProjectReportRow,
} from '../model/reportRow'

export const ProgramProjectReportNameCellRenderer = memo(
  ({ value, data }: ICellRendererParams<ProgramProjectReportRow>) => {
    return (
      <Root>
        {programProjectReportRowService.isProject(data) ? (
          <RowIcon src={data?.iconUrl || projectDefaultIcon} />
        ) : (
          data?.iconUrl && <RowIcon src={data.iconUrl} />
        )}
        <Label>{value}</Label>
      </Root>
    )
  },
  (prev, next) =>
    prev.value === next.value &&
    prev.data?.type === next.data?.type &&
    prev.data?.iconUrl === next.data?.iconUrl
)

const Root = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  overflow: 'hidden',
})

const RowIcon = styled('img')({
  width: 20,
  height: 20,
  flexShrink: 0,
})

const Label = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})
